import {
  checkLoginUrl,
  loginUser,
} from '@disco/state-management/actions/UserActions'
import getReferrer from '@disco/utils/getReferrer'

import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import type { State } from 'types/redux'
import DocumentHeadTags from 'components/document-head-tags'
import Button from 'components/ui/button'
import LoginError from 'components/utils/login-error'
import { useTranslation } from '@disco/i18n/use-translation'

const SamlWelcome = (): React.ReactElement<'div'> => {
  const { t } = useTranslation('accounts')
  const user: State['user'] = useSelector(state => state.user)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  useEffect(() => {
    dispatch(checkLoginUrl(getReferrer()))
  }, [dispatch])
  useEffect(() => {
    if (user.loginUrlCheckError) {
      const error = user.loginUrlCheckError

      if (error.body && error.body[0] === 'referer already used') {
        navigate('/logout?sessionExpired=1')
      }
    }
  }, [dispatch, user.loginUrlCheckError])

  const _onAccept = async () => {
    await dispatch(
      loginUser(
        {
          referer: getReferrer(),
          saml: true,
        },
        '/',
      ),
    )
  }

  const { loginUrlChecking, loginUrlCheckError } = user
  const passwordStrength =
    user.business?.public_metadata.password_strength ?? 'standard'
  let authState = <span />

  if (loginUrlChecking) {
    authState = <span>{t('accounts:authorizing', 'Authorizing...')}</span>
  } else if (loginUrlCheckError) {
    authState = (
      <div>
        <LoginError
          passwordStrength={passwordStrength}
          errorContext="link"
          error={loginUrlCheckError}
          suggestContactingSupport
        />
      </div>
    )
  } else {
    authState = (
      <Button
        appearance="primary"
        onClick={_onAccept}
        caption={t('accounts:createProfile', 'Create profile')}
      />
    )
  }

  return (
    <div className="PostInvites_Content">
      <DocumentHeadTags
        title={t(
          'accounts:createYourDiscoProfileDisco',
          'Create your DISCO profile | DISCO',
        )}
      />
      <h1 className="Form_Header PostInvites_Header">
        {t('accounts:createYourDiscoProfile', 'Create your DISCO profile')}
      </h1>
      {authState}
    </div>
  )
}

export default SamlWelcome
